var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('vue-good-table',{ref:"tabelaEmpresas",attrs:{"columns":_vm.colunas,"rows":_vm.dadosTabela,"row-style-class":"clickable","select-options":{
          enabled: true,
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },"theme":"view"},on:{"!on-selected-rows-change":function($event){return _vm.selecaoAlterada.apply(null, arguments)}}},[_c('div',{attrs:{"slot":"emptystate"},slot:"emptystate"},[_c('p',{staticStyle:{"text-align":"center","margin":"0"}},[_vm._v(" Nenhum registro encontrado. ")])])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }